module.exports = __webpack_public_path__ + "static/media/tech-man.e6acf749.jpg";